// ATALHOS INSTITUCIONAIS DO RODAPÉ ("descer pro rodapé", pedido do cs2619 em 26/08/2026)
//
// Páginas institucionais (Trabalhe conosco, Política de privacidade, Quem somos) saem do
// MENU e passam a viver no RODAPÉ como ÍCONE — clicar abre o conteúdo da própria página
// num modal, sem tirar o visitante da tela.
//
// ⚠️ GATE POR TENANT, de propósito. O rodapé 4 (Mega footer) está em 15 sites e hoje lista
// esses itens como TEXTO na coluna "Navegação". Trocar texto por ícone em todos mudaria a
// cara de 14 sites que não pediram — e o gatilho "óbvio" do dado (Menu=0 + Rodape=1) não
// serve: 226 tenants já têm páginas assim (medido em 26/08), inclusive 3 dos 15 do rodapé 4
// (834, 1890, 2059 — este último com 5 páginas, entre elas "Etapas do Financiamento
// Imobiliário", que não tem ícone que a represente). Para ligar em outro tenant, basta
// acrescentar o codsite em FOOTER_SHORTCUT_SITES.
import { removerAcentos } from './FunctionsGlobals';

/** Codsites onde as páginas institucionais descem do menu para o rodapé, em ícone. */
export const FOOTER_SHORTCUT_SITES = new Set<number>([2619]);

export type FooterShortcutKey = 'trabalhe' | 'privacidade' | 'quem-somos';

/**
 * Reconhecimento por TÍTULO (o cliente escolhe o nome da página no CRM), com acento e
 * caixa normalizados. Só estes três descem — "Anuncie seu imóvel", "Blog" e afins seguem
 * no menu e na lista de texto do rodapé, como sempre.
 */
const PADROES: Array<{ key: FooterShortcutKey; re: RegExp }> = [
    { key: 'trabalhe', re: /trabalhe\s*conosco|trabalhe\s*com\s*a\s*gente|seja\s*um\s*corretor|faca\s*parte\s*da\s*equipe/ },
    { key: 'privacidade', re: /politica\s*de\s*privacidade|privacidade\s*e?\s*(dados|lgpd)?|lgpd/ },
    { key: 'quem-somos', re: /quem\s*somos|sobre\s*nos|a\s*empresa|nossa\s*historia|institucional/ },
];

const normaliza = (valor: unknown): string =>
    removerAcentos(String(valor ?? ''))
        .toLowerCase()
        .replace(/\s+/g, ' ')
        .trim();

/** O tenant usa atalhos em ícone no rodapé? */
export function siteUsaAtalhosRodape(site: any): boolean {
    return FOOTER_SHORTCUT_SITES.has(Number(site?.id));
}

/** Qual atalho este título representa (null = não é um atalho institucional). */
export function chaveDoAtalho(titulo: unknown): FooterShortcutKey | null {
    const t = normaliza(titulo);
    if (!t) return null;
    return PADROES.find((p) => p.re.test(t))?.key ?? null;
}

/**
 * Este item de menu deve SAIR do menu (topo/drawer) e virar ícone no rodapé?
 * Vale só para página institucional do próprio CRM (sem `link` externo) e apenas nos
 * tenants do gate — em qualquer outro caso devolve false e nada muda.
 */
export function ehAtalhoDeRodape(site: any, menu: any): boolean {
    if (!siteUsaAtalhosRodape(site)) return false;
    if (menu?.link) return false; // item que aponta pra URL própria continua no menu
    return chaveDoAtalho(menu?.titulo) != null;
}
